import { Button, Flex, Typography } from '@iheartjane/reefer';

import { useKioskSpacing } from '../../../hooks';
import { useBrandSpecials } from '../../../providers';
import { Modal } from '../Modal';

export const BagAlert = ({
  isOpen,
  onRequestClose,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
}) => {
  const { defaultSpacing, getKioskSpacing, isIpad } = useKioskSpacing();
  const { addedBrandSpecialIds, removedBrandSpecialIds, cart } =
    useBrandSpecials();

  const alertMessage =
    cart?.brand_discounts_total && cart.brand_discounts_total > 0
      ? removedBrandSpecialIds?.length > 0
        ? 'You are no longer eligible for some of your Jane Gold cash back rewards.'
        : addedBrandSpecialIds?.length === 1
          ? 'You are now eligible for a new Jane Gold cash back reward.'
          : addedBrandSpecialIds?.length > 1
            ? 'You are now eligible for new Jane Gold rewards.'
            : 'Your Jane Gold cash back rewards have been updated.'
      : removedBrandSpecialIds?.length > 0
        ? 'You are no longer eligible for your Jane Gold cash back rewards.'
        : 'Your Jane Gold cash back rewards have been updated.';

  return (
    <Modal
      appId="root"
      contentLabel="Bag Alert"
      onRequestClose={onRequestClose}
      open={isOpen}
      overlayClose
      variant="dialogue"
    >
      <Modal.Content>
        <Flex flexDirection="column">
          <Typography variant="title-bold" mb={getKioskSpacing(24, 8)}>
            Bag updated
          </Typography>

          <Typography mb={defaultSpacing}>
            {alertMessage} View your bag for more information.
          </Typography>
          <Button
            label="OK"
            onClick={onRequestClose}
            full
            branded
            size={isIpad ? 'small' : 'default'}
          />
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
